@import 'styles/variables';
@import 'styles/blaze/mixins';
@import 'styles/mixins';

.reviewContent {
  display: flex;
  gap: 30px;
}

.formSection {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 400px;
}

.topicLabel {
  height: 32px;
}

.sourceHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.textarea {
  @include md-sohne;
  border-radius: 15px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);

  resize: none;

  width: 100%;
  height: 368px;
  padding: 20px;

  &:focus {
    outline: none;
    border-color: var(--selected-stroke);
    box-shadow: 0 0 0 2px var(--selected-fill-10);
  }
}

.thumbnailContainer {
  width: 100%;
  background: var(--light-100);
  border-radius: 15px;
  display: block;
  padding: 0;
  border: none;
  cursor: pointer;
  overflow: hidden;

  &--landscape {
    aspect-ratio: 16 / 9;
    max-height: 350px;
  }

  &--portrait {
    aspect-ratio: 3 / 4;
    max-height: 500px;
  }

  &--square {
    aspect-ratio: 1;
    max-height: 380px;
  }
}

.thumbnail {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.thumbnailPreview {
  width: fit-content;
  margin: 0 auto;

  img,
  video {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    border-radius: 15px;
  }

  &--portrait img,
  &--portrait video {
    max-height: 650px;
  }

  &--landscape img,
  &--landscape video {
    max-height: 500px;
  }

  &--square img,
  &--square video {
    max-height: 450px;
  }
}

.error {
  margin-top: 12px;
  padding: 12px;
  background: var(--error-fill-10);
  border: 1px solid var(--error-stroke);
  border-radius: 8px;
  color: var(--error-text);
  font-size: 14px;
}

.generationCostContainer {
  display: flex;
  align-items: center;
  gap: 4px;
}

.generationCost {
  display: flex;
  align-items: center;
  gap: 2px;
  color: var(--light-60);
}

.avatarLoading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}
